import Vue from 'vue'
import VueRouter from 'vue-router'
import Sleep from '@/components/sleep.vue'
import SettingPanel from '@/components/SettingPanel.vue'
import RotationConfigPanel from '@/components/RotationConfigPanel.vue'
import VideoConfigPanel from '@/components/VideoConfigPanel.vue'
import Login from '@/components/Login.vue'
import { isAuthenticated } from '@/utils/auth'
import logger from '@/utils/logger'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Home',
    component: Sleep,
    props: route => ({
      storeId: route.query.store || route.params.storeId
    }),
    meta: { requiresAuth: false }
  },
  {
    path: '/store/:storeId',
    name: 'Store',
    component: Sleep,
    props: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: SettingPanel,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/rotation',
    name: 'AdminRotation',
    component: RotationConfigPanel,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/videos',
    name: 'AdminVideos',
    component: VideoConfigPanel,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫：检查登录状态
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const authenticated = isAuthenticated();
  
  logger.debug('[路由守卫]', {
    path: to.path,
    requiresAuth,
    authenticated,
    from: from.path
  });
  
  // 如果路由需要认证
  if (requiresAuth) {
    // 检查是否已登录
    if (!authenticated) {
      logger.debug('[路由守卫] 需要登录但未登录，跳转到登录页');
      // 未登录，跳转到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 保存原始路径，登录后可以跳转回去
      })
    } else {
      logger.debug('[路由守卫] 已登录，允许访问');
      // 已登录，允许访问
      next()
    }
  } else {
    // 不需要认证的路由（如登录页、大屏页面）
    if (to.path === '/login' && authenticated) {
      logger.debug('[路由守卫] 已登录用户访问登录页，跳转到管理页面');
      next('/admin')
    } else {
      logger.debug('[路由守卫] 不需要认证，允许访问');
      next()
    }
  }
})

export default router